var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.route == `/provider/prior-auth`)?_c('PriorTable'):_vm._e(),(_vm.route == `/provider/prior-auth/new-request`)?_c('PriorRequest'):_vm._e(),(_vm.route == `/provider/prior-auth/determination`)?_c('PriorDetermination'):_vm._e(),(_vm.route == `/provider/prior-auth/details`)?_c('Details'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }